import { cva } from 'class-variance-authority';

// keeping empty strings here, so styles can be easily added without modifying any other file
export const checkboxRootVariants = cva('gap-md', {
  variants: {
    checked: {
      false: '',
      true: '',
    },
    indeterminate: {
      false: '',
      true: '',
    },
    disabled: {
      false: '',
      true: '!cursor-not-allowed [&_*]:!cursor-not-allowed',
    },
    readOnly: {
      false: '',
      true: '',
    },
    focusVisible: {
      false: '',
      true: '',
    },
    size: {
      sm: '',
      md: '',
    },
  },
  defaultVariants: {
    checked: false,
    indeterminate: false,
    disabled: false,
    readOnly: false,
    focusVisible: false,
  },
});

// keeping empty strings here, so styles can be easily added without modifying any other file
export const checkboxActionVariants = cva('', {
  variants: {
    checked: {
      false: '',
      true: '',
    },
    indeterminate: {
      false: '',
      true: '',
    },
    disabled: {
      false: '',
      true: '',
    },
    readOnly: {
      false: '',
      true: '',
    },
    focusVisible: {
      false: '',
      true: '',
    },
    size: {
      sm: '',
      md: '',
    },
  },
  defaultVariants: {
    checked: false,
    indeterminate: false,
    disabled: false,
    readOnly: false,
    focusVisible: false,
  },
});

// keeping empty strings here, so styles can be easily added without modifying any other file
export const checkboxLabelVariants = cva('text-sm font-medium text-secondary', {
  variants: {
    checked: {
      false: '',
      true: '',
    },
    indeterminate: {
      false: '',
      true: '',
    },
    disabled: {
      false: '',
      true: '',
    },
    readOnly: {
      false: '',
      true: '',
    },
    focusVisible: {
      false: '',
      true: '',
    },
    size: {
      sm: '',
      md: '',
    },
  },
  defaultVariants: {
    checked: false,
    indeterminate: false,
    disabled: false,
    readOnly: false,
    focusVisible: false,
  },
});
